<template>
 <div v-if="user">
   <button class="mx-1 btn btn-secondary rounded-pill">
     <i class="bi bi-wallet2"/>
     {{ $t('wallet.wallet_widget.button_text') }}
     {{ formatNumber(profileWalletValue) }}
   </button>
 </div>

</template>

<script>
import {mapGetters} from "vuex";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "WalletValue1",
  props: {

  },
  computed:{
    ...mapGetters({
      profile: 'User/getProfile',
      user: "User/isAuthenticated"
    }),
    profileWalletValue() {

      let profile = this.profile

      if (profile.wallet != null) {
        return profile.wallet.value
      }

      return 0
    },
  },
  methods: {
    formatNumber

  }
}
</script>

<style scoped>


</style>